<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item>已发作业</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 content_box overflow" :style="{ height: height + 'px' }">
			<perform-list @submit='submit'></perform-list>
		</div>
		<pop-up :show="show" :id="id" @closes='closes' @goButton='goButton'></pop-up>
	</div>
</template>

<script>
import PerformList from './commponents/performList.vue';
import PopUp from './commponents/popUp.vue'
export default {
	name: 'Sent',
	components:{
		PerformList,
		PopUp
	},
	data() {
		return {
			height: 0,
			show:false,
			id:0
		};
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Sent') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		submit(val,id){
			// console.log(val,id)
			this.id=id
			this.show = val
		},
		closes(val){
			this.show = val
		},
		goButton(val){
			this.show = val
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	background-color: #ffffff;
	// padding: 0 260px;
	padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/sent/index.vue